import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ClipboardList, Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';

const CTASection: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section className="py-16 md:py-24 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('home.cta.title')}
          </h2>
          <p className="text-lg text-white/80 max-w-2xl mx-auto">
            {t('home.cta.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          {/* Project CTA */}
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 text-center border border-white/10">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-primary/20 mb-4">
              <ClipboardList className="h-6 w-6 text-primary" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">
              {t('home.cta.project.title')}
            </h3>
            <p className="text-white/75 text-sm mb-5">
              {t('home.cta.project.description')}
            </p>
            <Button asChild size="lg" className="w-full">
              <Link to="/presupuesto">
                {t('home.cta.project.button')}
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>

          {/* Inspection CTA */}
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 text-center border border-white/10">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-primary/20 mb-4">
              <Shield className="h-6 w-6 text-primary" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">
              {t('home.cta.inspection.title')}
            </h3>
            <p className="text-white/75 text-sm mb-5">
              {t('home.cta.inspection.description')}
            </p>
            <Button asChild size="lg" className="w-full">
              <Link to="/inspeccion-de-rocodromos">
                {t('home.cta.inspection.button')}
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
